export default __webpack_public_path__ + "static/media/pasti-pas.5e56c735.png";